export default __webpack_public_path__ + "static/media/5.8c5232f5.jpeg";